module.exports = __webpack_public_path__ + "img/Item6light.55ba99eb.svg";